import TicketPhotos from './TicketPhotos';

export default TicketPhotos;
